import React, { FC, useRef, useEffect } from "react";
import { EventDetails } from "../EventDetails";
import { EventDetailsVariant } from "../EventDetails/EventDetails";
import "./Modal.css"; // You can create a separate CSS file for modal styles
import { CalendarItem } from "../types";

interface ModalProps {
	isOpen: boolean;
	closeModal: () => void;
	event: CalendarItem | null;
	modalDate: Date;
}

const Modal: FC<ModalProps> = ({ isOpen, closeModal, event, modalDate }) => {
	const modalRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			const target = event.target as EventTarget & HTMLElement;

			if (modalRef.current && target.classList.contains("scb-modal-overlay")) {
				closeModal();
			}
		};

		if (isOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isOpen, closeModal]);

	if (!isOpen || !event) {
		return null;
	}

	return (
		<div
			className="scb-modal-overlay"
			ref={modalRef}
		>
			<div className="scb-modal-content">
				<button
					className="scb-close-button"
					onClick={closeModal}
				>
					&#215;
				</button>
				<EventDetails
					dayDate={modalDate}
					event={event}
					variant={EventDetailsVariant.POPUP}
				/>
			</div>
		</div>
	);
};

export default Modal;
